module.exports = __webpack_public_path__ + "img/101025.a91194de.png";